import { z } from 'zod';

export const aoCreateDraftValidationSchema = () =>
  z.object({
    ppmId: z.number({ required_error: 'Le PPM est obligatoire' }).min(1, 'Le PPM ne doit pas être vide'),
    ppmVer: z.number({ required_error: 'Le PPM est obligatoire' }).min(1, 'Le PPM ne doit pas être vide'),
    realisationId: z.number({ required_error: 'La réalisation est obligatoire' }).min(1, 'La réalisation ne doit pas être vide'),
    realisationVer: z.number({ required_error: 'La réalisation est obligatoire' }).min(1, 'La réalisation ne doit pas être vide'),
    nom: z
      .string({ required_error: 'Le nom est obligatoire' })
      .min(1, 'Le nom ne doit pas être vide')
      .max(250, 'ce champ ne doit pas dépasser 250 caractères.'),
  });

export const aoUpdateDraftValidationSchema = () =>
  z.object({
    nom: z
      .string({ required_error: 'Le nom est obligatoire' })
      .min(1, 'Le nom ne doit pas être vide')
      .max(250, 'ce champ ne doit pas dépasser 250 caractères.'),
  });
